import moment from "moment";

export function getTextWidth(text, font = '17px AvenirBook') {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return Math.round(metrics.width);
}

export function getTextWidthInDecimals(text, font = '17px AvenirBook') {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
}

export function getPercentageSpanWidth(percentage = 0) {
  const span = document.createElement('span');
  span.style.width = `${percentage}%`;
  span.style.display = 'inline-block';
  span.style.position = 'absolute';
  span.style.visibility = 'hidden';

  // Attach to body temporarily for layout calc
  document.body.appendChild(span);

  const width = span.offsetWidth;

  document.body.removeChild(span);
  return width;
}


export function truncateToWidth(text, maxWidth, font = '17px AvenirBook') {
  const ellipsis = '...';
  const ellipsisWidth = getTextWidth(ellipsis, font);

  let truncated = '';
  for (let i = 0; i < text.length; i++) {
    const current = text.slice(0, i + 1);
    const width = getTextWidth(current, font);
    if (width + ellipsisWidth > maxWidth) break;
    truncated = current;
  }

  const finalWidth = getTextWidth(text, font);
  return finalWidth > maxWidth ? truncated + ellipsis : text;
}

export function wrapTextToWidth(text, maxWidth, font = '17px AvenirBook') {
  const words = text.split(' ');
  const lines = [];
  let currentLine = '';

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    const testLine = currentLine ? `${currentLine} ${word}` : word;
    const width = getTextWidth(testLine, font);

    if (width <= maxWidth) {
      currentLine = testLine;
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  }

  if (currentLine) lines.push(currentLine);

  return lines; // returns an array of line strings
}



export function transformPhaseData(originalData) {
  // Group data by phaseTitle
  const groupedData = {};
  
  originalData.forEach(item => {
    if (!groupedData[item.phaseTitle]) {
      groupedData[item.phaseTitle] = [];
    }
    groupedData[item.phaseTitle].push(item);
  });

  // Transform to the desired format
  const transformedData = [];
  let idCounter = 1;

  Object.keys(groupedData).forEach(phaseTitle => {
    const subTasks = groupedData[phaseTitle].map(item => ({
      id: item.phaseId,
      goal: item.goalDescription,
      status: "pending", // Default status
      stepId: item.phaseId, // Using phaseId as stepId
      enddate: item.endDate,
      startdate: item.startDate
    }));

    transformedData.push({
      id: idCounter++,
      step: phaseTitle,
      subTasks: subTasks
    });
  });

  return transformedData;
}

export function reverseTransformPhaseData(transformedData) {
  const originalFormatData = [];
  
  transformedData.forEach(step => {
    step.subTasks.forEach(subTask => {
      const originalItem = {
        phaseId: subTask.id,
        phaseTitle: step.step,
        goalDescription: subTask.goal,
        startDate: subTask.startdate,
        endDate: subTask.enddate
      };
      
      originalFormatData.push(originalItem);
    });
  });
  
  return originalFormatData;
}

export async function adjustPhaseDatesAfterSubtaskEdit(timeline, phaseIndex = 0, flattedSTG, stgIndexArr = []){

  phaseIndex = phaseIndex === null ? 0 : phaseIndex
  console.log('sss updated adjustPhaseDatesAfterSubtaskEdit 1', timeline, phaseIndex, flattedSTG, stgIndexArr)
  
  const filteredSTG = flattedSTG.filter((_, index) => stgIndexArr.includes(index));
  console.log('sss updated adjustPhaseDatesAfterSubtaskEdit 2', filteredSTG)

  const defaultDate = moment().format('YYYY-MM-DD'); // or any default date you prefer

  const smallestStartDate = filteredSTG.length > 0 
    ? filteredSTG.reduce((min, task) => 
        task.startdate < min ? task.startdate : min, filteredSTG[0].startdate
      )
    : defaultDate;

  const highestEndDate = filteredSTG.length > 0 
    ? filteredSTG.reduce((max, task) => 
        task.enddate > max ? task.enddate : max, filteredSTG[0].enddate
      )
    : defaultDate;

  console.log('sss updated adjustPhaseDatesAfterSubtaskEdit 3', smallestStartDate, highestEndDate, timeline[phaseIndex]);

  timeline[phaseIndex].startDate = smallestStartDate
  timeline[phaseIndex].endDate = highestEndDate

  if( filteredSTG.length === 1 ){
    console.log('sss updated adjustPhaseDatesAfterSubtaskEdit 4', filteredSTG.length)
    timeline[phaseIndex].goalDescription = filteredSTG[0].goal
  }

//   timeline = timeline.map((phase, index) => {
//   if (index === phaseIndex) {
//     return {
//       ...phase,
//       startDate: smallestStartDate,
//       endDate: highestEndDate
//     };
//   }
//   return phase;
// });

  // const updatedTimeline = reduceTimeline(timeline, phaseIndex)
  const updatedTimeline = await mergePhaseDates(timeline, timeline[phaseIndex].phaseTitle, timeline[phaseIndex].goalDescription)
  return updatedTimeline

}

function mergePhaseDates(data, targetPhaseTitle, targetPhaseDesc) {
  // Filter items with the target phase title
  const targetPhases = data.filter(item => item.phaseTitle === targetPhaseTitle);
  const otherPhases = data.filter(item => item.phaseTitle !== targetPhaseTitle);
  
  if (targetPhases.length <= 1) {
    return data; // No merging needed if 0 or 1 item
  }
  
  // Helper function to check if two date ranges overlap or one contains another
  function datesOverlapOrContain(start1, end1, start2, end2) {
    const s1 = new Date(start1);
    const e1 = new Date(end1);
    const s2 = new Date(start2);
    const e2 = new Date(end2);
    
    // Check if ranges overlap or one contains another
    return (s1 <= e2 && s2 <= e1);
  }
  
  // Helper function to get the earliest start date
  function getEarliestDate(date1, date2) {
    return new Date(date1) <= new Date(date2) ? date1 : date2;
  }
  
  // Helper function to get the latest end date
  function getLatestDate(date1, date2) {
    return new Date(date1) >= new Date(date2) ? date1 : date2;
  }
  
  // Keep merging until no more merges are possible
  let mergedPhases = [...targetPhases];
  let changesMade = true;
  
  while (changesMade) {
    changesMade = false;
    
    for (let i = 0; i < mergedPhases.length; i++) {
      for (let j = i + 1; j < mergedPhases.length; j++) {
        const phase1 = mergedPhases[i];
        const phase2 = mergedPhases[j];
        
        // Check if phases overlap or one contains another
        if (datesOverlapOrContain(phase1.startDate, phase1.endDate, phase2.startDate, phase2.endDate)) {
          // Merge the phases
          const mergedPhase = {
            ...phase1, // Keep properties from first phase
            startDate: getEarliestDate(phase1.startDate, phase2.startDate),
            endDate: getLatestDate(phase1.endDate, phase2.endDate),
            // You might want to merge other properties differently
            // goalDescription: `${phase1.goalDescription} + ${phase2.goalDescription}` // Example merge
            goalDescription: targetPhaseDesc // Example merge
          };
          
          // Remove the two phases and add the merged one
          mergedPhases.splice(j, 1); // Remove second phase first (higher index)
          mergedPhases.splice(i, 1); // Remove first phase
          mergedPhases.push(mergedPhase); // Add merged phase
          
          changesMade = true;
          break; // Break inner loop and start over
        }
      }
      if (changesMade) break; // Break outer loop and start over
    }
  }
  
  // Return the complete array with merged phases
  return [...otherPhases, ...mergedPhases];
}


export function adjustPhaseDatesAfterSubtaskDeletion(shortTermGoals, phases, deletedSubtaskId) {
  // Find the deleted subtask and its parent goal
  let deletedSubtask = null;
  let parentGoal = null;

  for (let goal of shortTermGoals) {
    const foundSubtask = goal.subTasks.find(subtask => subtask.id === deletedSubtaskId);
    console.log("searching in Subtask", goal.subTasks, foundSubtask)
    if (foundSubtask) {
      deletedSubtask = foundSubtask;
      parentGoal = goal;
      break;
    }
  }
  
  if (!deletedSubtask || !parentGoal) {
    console.log('Subtask not found');
    return phases;
  }
  
  console.log('Deleted subtask:', deletedSubtask);
  console.log('Parent goal step:', parentGoal.step);
  
  // Find all remaining subtasks for the same step/phase
  const remainingSubtasks = parentGoal.subTasks.filter(subtask => subtask.id !== deletedSubtaskId);
  
  console.log('Remaining subtasks:', remainingSubtasks);
  
  // Update phases that match the parent goal's step
  const updatedPhases = phases.map((phase, index) => {
    if (phase.phaseTitle.toLowerCase() === parentGoal.step.toLowerCase()) {

      if( moment(deletedSubtask.startdate).isBetween(moment(phase.startDate), moment(phase.endDate)) && moment(deletedSubtask.enddate).isBetween(moment(phase.startDate), moment(phase.endDate)) ){
        console.log('yes startdate & enddate excluded but inBetween phase', index, phase)
        if(parentGoal.subTasks.length === 1){
          // console.log('yes startdate & enddate excluded but inBetween phase only 1 ')
          return null;
        }
      }
      else if( moment(deletedSubtask.startdate).isBetween(moment(phase.startDate), moment(phase.endDate), null, '[]') && moment(deletedSubtask.enddate).isBetween(moment(phase.startDate), moment(phase.endDate), null, '[]') ){
        console.log('yes startdate & enddate included inBetween phase', index, phase)

        const newSubTasks = remainingSubtasks.reduce((acc, subGoal, index) => {
          
          if( moment(subGoal.startdate).isBetween(moment(phase.startDate), moment(phase.endDate), null, '[]') && moment(subGoal.enddate).isBetween(moment(phase.startDate), moment(phase.endDate), null, '[]') ){
            acc.push(subGoal);
          }
          return acc
        }, [])

        console.log('yes new subtasks', newSubTasks)

        if (newSubTasks.length > 0) {
          const smallestStartDate = newSubTasks.reduce((min, task) => 
            task.startdate < min ? task.startdate : min, newSubTasks[0].startdate
          );
          
          const highestEndDate = newSubTasks.reduce((max, task) => 
            task.enddate > max ? task.enddate : max, newSubTasks[0].enddate
          );
            
          console.log('Smallest start date:', smallestStartDate); // "2025-04-11"
          console.log('Highest end date:', highestEndDate); // "2025-07-01"
  
          return { 
            ...phase, 
            startDate: smallestStartDate,
            endDate: highestEndDate
          };
        }
        else {
          return null
        }
      }     
    }
    
    return phase;
  }).filter(phase => phase !== null); // Remove null phases

  console.log('updatedPhases', updatedPhases)
  
  return updatedPhases;
} 